// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Env = require("../../reason/common/Env.bs.js");
let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Loader = require("../common/Components/Loader.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let ReasonPromise = require("../../reason/ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let AvatarUploadProvider = require("../../reason/settings/components/AvatarUploadProvider.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SelectProfilePhotoButton = require("../common/Components/SelectProfilePhotoButton.bs.js");
let UnifiedProfileImageFieldLogoMutation_graphql = require("../../__generated__/UnifiedProfileImageFieldLogoMutation_graphql.bs.js");
let UnifiedProfileImageFieldTeamPhotoMutation_graphql = require("../../__generated__/UnifiedProfileImageFieldTeamPhotoMutation_graphql.bs.js");
let UnifiedProfileImageFieldRemoveLogoMutation_graphql = require("../../__generated__/UnifiedProfileImageFieldRemoveLogoMutation_graphql.bs.js");
let UnifiedProfileImageFieldFeaturedPhotoMutation_graphql = require("../../__generated__/UnifiedProfileImageFieldFeaturedPhotoMutation_graphql.bs.js");
let UnifiedProfileImageFieldRemoveTeamPhotoMutation_graphql = require("../../__generated__/UnifiedProfileImageFieldRemoveTeamPhotoMutation_graphql.bs.js");
let UnifiedProfileImageFieldRemoveFeaturedPhotoMutation_graphql = require("../../__generated__/UnifiedProfileImageFieldRemoveFeaturedPhotoMutation_graphql.bs.js");

let convertVariables = UnifiedProfileImageFieldLogoMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedProfileImageFieldLogoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedProfileImageFieldLogoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedProfileImageFieldLogoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedProfileImageFieldLogoMutation_graphql.node, convertResponse, convertWrapRawResponse);

let LogoMutation_imageContentType_decode = UnifiedProfileImageFieldLogoMutation_graphql.Utils.imageContentType_decode;

let LogoMutation_imageContentType_fromString = UnifiedProfileImageFieldLogoMutation_graphql.Utils.imageContentType_fromString;

let LogoMutation = {
  imageContentType_decode: LogoMutation_imageContentType_decode,
  imageContentType_fromString: LogoMutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertVariables$1 = UnifiedProfileImageFieldRemoveLogoMutation_graphql.Internal.convertVariables;

let convertResponse$1 = UnifiedProfileImageFieldRemoveLogoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = UnifiedProfileImageFieldRemoveLogoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, UnifiedProfileImageFieldRemoveLogoMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, UnifiedProfileImageFieldRemoveLogoMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let RemoveLogoMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

let convertVariables$2 = UnifiedProfileImageFieldTeamPhotoMutation_graphql.Internal.convertVariables;

let convertResponse$2 = UnifiedProfileImageFieldTeamPhotoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = UnifiedProfileImageFieldTeamPhotoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$2 = RescriptRelay_Mutation.commitMutation(convertVariables$2, UnifiedProfileImageFieldTeamPhotoMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$2, UnifiedProfileImageFieldTeamPhotoMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let TeamPhotoMutation_imageContentType_decode = UnifiedProfileImageFieldTeamPhotoMutation_graphql.Utils.imageContentType_decode;

let TeamPhotoMutation_imageContentType_fromString = UnifiedProfileImageFieldTeamPhotoMutation_graphql.Utils.imageContentType_fromString;

let TeamPhotoMutation = {
  imageContentType_decode: TeamPhotoMutation_imageContentType_decode,
  imageContentType_fromString: TeamPhotoMutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation$2,
  use: use$2
};

let convertVariables$3 = UnifiedProfileImageFieldRemoveTeamPhotoMutation_graphql.Internal.convertVariables;

let convertResponse$3 = UnifiedProfileImageFieldRemoveTeamPhotoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$3 = UnifiedProfileImageFieldRemoveTeamPhotoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$3 = RescriptRelay_Mutation.commitMutation(convertVariables$3, UnifiedProfileImageFieldRemoveTeamPhotoMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

let use$3 = RescriptRelay_Mutation.useMutation(convertVariables$3, UnifiedProfileImageFieldRemoveTeamPhotoMutation_graphql.node, convertResponse$3, convertWrapRawResponse$3);

let RemoveTeamPhotoMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$3,
  convertResponse: convertResponse$3,
  convertWrapRawResponse: convertWrapRawResponse$3,
  commitMutation: commitMutation$3,
  use: use$3
};

let convertVariables$4 = UnifiedProfileImageFieldFeaturedPhotoMutation_graphql.Internal.convertVariables;

let convertResponse$4 = UnifiedProfileImageFieldFeaturedPhotoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$4 = UnifiedProfileImageFieldFeaturedPhotoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$4 = RescriptRelay_Mutation.commitMutation(convertVariables$4, UnifiedProfileImageFieldFeaturedPhotoMutation_graphql.node, convertResponse$4, convertWrapRawResponse$4);

let use$4 = RescriptRelay_Mutation.useMutation(convertVariables$4, UnifiedProfileImageFieldFeaturedPhotoMutation_graphql.node, convertResponse$4, convertWrapRawResponse$4);

let FeaturedPhotoMutation_imageContentType_decode = UnifiedProfileImageFieldFeaturedPhotoMutation_graphql.Utils.imageContentType_decode;

let FeaturedPhotoMutation_imageContentType_fromString = UnifiedProfileImageFieldFeaturedPhotoMutation_graphql.Utils.imageContentType_fromString;

let FeaturedPhotoMutation = {
  imageContentType_decode: FeaturedPhotoMutation_imageContentType_decode,
  imageContentType_fromString: FeaturedPhotoMutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$4,
  convertResponse: convertResponse$4,
  convertWrapRawResponse: convertWrapRawResponse$4,
  commitMutation: commitMutation$4,
  use: use$4
};

let convertVariables$5 = UnifiedProfileImageFieldRemoveFeaturedPhotoMutation_graphql.Internal.convertVariables;

let convertResponse$5 = UnifiedProfileImageFieldRemoveFeaturedPhotoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$5 = UnifiedProfileImageFieldRemoveFeaturedPhotoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$5 = RescriptRelay_Mutation.commitMutation(convertVariables$5, UnifiedProfileImageFieldRemoveFeaturedPhotoMutation_graphql.node, convertResponse$5, convertWrapRawResponse$5);

let use$5 = RescriptRelay_Mutation.useMutation(convertVariables$5, UnifiedProfileImageFieldRemoveFeaturedPhotoMutation_graphql.node, convertResponse$5, convertWrapRawResponse$5);

let RemoveFeaturedPhotoMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$5,
  convertResponse: convertResponse$5,
  convertWrapRawResponse: convertWrapRawResponse$5,
  commitMutation: commitMutation$5,
  use: use$5
};

function useLogo() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedTeamLogo;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

function useRemoveLogo() {
  let match = use$1();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit(input, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.removeUnifiedTeamLogo;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

function useTeamPhoto() {
  let match = use$2();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedTeamPhoto;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

function useRemoveTeamPhoto() {
  let match = use$3();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit(input, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.removeUnifiedTeamPhoto;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

function usePersonalFeaturedPhoto() {
  let match = use$4();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedFeaturedPhoto;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "Your changes could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UnifiedPersonalProfileUpdated" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "UnifiedProfileUpdateFailed" :
        return {
          TAG: "Error",
          _0: match.message
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "Your changes could not be saved. Please try again."
        };
    }
  });
}

function usePersonalRemoveFeaturedPhoto() {
  let match = use$5();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit(input, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.removeUnifiedFeaturedPhoto;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "Your changes could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UnifiedPersonalProfileUpdated" :
        return {
          TAG: "Ok",
          _0: undefined
        };
      case "UnifiedProfileUpdateFailed" :
        return {
          TAG: "Error",
          _0: match.message
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "Your changes could not be saved. Please try again."
        };
    }
  });
}

function UnifiedProfileImageField(props) {
  let kind = props.kind;
  let url = props.url;
  let label = props.label;
  let match = useLogo();
  let saveLogo = match[0];
  let match$1 = useRemoveLogo();
  let removeLogo = match$1[0];
  let match$2 = useTeamPhoto();
  let saveTeamPhoto = match$2[0];
  let match$3 = useRemoveTeamPhoto();
  let removeTeamPhoto = match$3[0];
  let match$4 = usePersonalFeaturedPhoto();
  let saveFeatured = match$4[0];
  let match$5 = usePersonalRemoveFeaturedPhoto();
  let removeFeatured = match$5[0];
  let uploadImage = AvatarUploadProvider.useUploadImage();
  let match$6 = React.useState(() => false);
  let setUploading = match$6[1];
  let match$7 = React.useState(() => {});
  let setError = match$7[1];
  let error = match$7[0];
  let match$8 = React.useState(() => url);
  let setCurrentUrl = match$8[1];
  let currentUrl = match$8[0];
  let saving = match$6[0] || match[1] || match$1[1] || match$2[1] || match$3[1] || match$4[1] || match$5[1];
  let failed = message => {
    setUploading(param => false);
    setError(param => message);
  };
  let onSelect = file => {
    setUploading(param => true);
    setError(param => {});
    ReasonPromise.get(uploadImage(file), result => {
      if (result.TAG === "Ok") {
        let match = result._0;
        let match$1 = match.dimensions;
        let info = match.info;
        let contentType = SelectProfilePhotoButton.ImageMimeType.parse(info.contentType);
        if (contentType.TAG !== "Ok") {
          return failed("Please choose a PNG, JPEG, GIF or WebP image.");
        }
        let contentType$1 = contentType._0;
        let image_contentType = contentType$1 === "PNG" ? "PNG" : (
            contentType$1 === "JPEG" ? "JPEG" : (
                contentType$1 === "WEBP" ? "WEBP" : "GIF"
              )
          );
        let image_fileName = info.fileName;
        let image_height = match$1.height;
        let image_key = info.key;
        let image_uploadId = info.id;
        let image_width = match$1.width;
        let image = {
          contentType: image_contentType,
          fileName: image_fileName,
          height: image_height,
          key: image_key,
          uploadId: image_uploadId,
          width: image_width
        };
        let done = () => {
          setUploading(param => false);
          setCurrentUrl(param => Env.attachment_prefix + "/" + info.key);
        };
        switch (kind) {
          case "Featured" :
            return saveFeatured(image, () => done(), failed);
          case "TeamPhoto" :
            return saveTeamPhoto(image, () => done(), failed);
          case "Logo" :
            return saveLogo(image, () => done(), failed);
        }
      } else {
        let message = result._0;
        if (typeof message !== "object") {
          return failed("This file could not be read as an image.");
        } else {
          return failed(message._0);
        }
      }
    });
  };
  let remove = () => {
    setError(param => {});
    switch (kind) {
      case "Featured" :
        return removeFeatured(undefined, () => setCurrentUrl(param => {}), failed);
      case "TeamPhoto" :
        return removeTeamPhoto(undefined, () => setCurrentUrl(param => {}), failed);
      case "Logo" :
        return removeLogo(undefined, () => setCurrentUrl(param => {}), failed);
    }
  };
  let tmp;
  if (error !== undefined) {
    tmp = JsxRuntime.jsx(Alert.$$Error.make, {
      title: error
    });
  } else {
    switch (kind) {
      case "Featured" :
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            match$4[2],
            match$5[2]
          ]
        });
        break;
      case "TeamPhoto" :
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            match$2[2],
            match$3[2]
          ]
        });
        break;
      case "Logo" :
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            match[2],
            match$1[2]
          ]
        });
        break;
    }
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Form__Label.make, {
            labelText: label
          }),
          JsxRuntime.jsx("p", {
            children: props.helpText,
            className: "text-zinc-500"
          })
        ],
        className: "sm:col-span-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          currentUrl !== undefined ? JsxRuntime.jsx("img", {
              className: "max-h-80 max-w-full rounded object-contain",
              alt: label,
              src: currentUrl
            }) : null,
          saving ? JsxRuntime.jsx(Loader.make, {}) : JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(SelectProfilePhotoButton.make, {
                  onSelectProfilePhoto: onSelect,
                  acceptedImageTypes: [
                    "JPEG",
                    "PNG",
                    "GIF",
                    "WEBP"
                  ],
                  children: "Choose image"
                }),
                Stdlib_Option.isSome(currentUrl) ? JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: param => remove(),
                    children: "Remove image"
                  }) : null
              ],
              className: "flex gap-4"
            }),
          tmp
        ],
        className: "space-y-4 sm:col-span-3"
      })
    ],
    className: "space-y-6 py-6 sm:grid sm:grid-cols-5 sm:items-start sm:gap-16"
  });
}

let make = UnifiedProfileImageField;

exports.LogoMutation = LogoMutation;
exports.RemoveLogoMutation = RemoveLogoMutation;
exports.TeamPhotoMutation = TeamPhotoMutation;
exports.RemoveTeamPhotoMutation = RemoveTeamPhotoMutation;
exports.FeaturedPhotoMutation = FeaturedPhotoMutation;
exports.RemoveFeaturedPhotoMutation = RemoveFeaturedPhotoMutation;
exports.useLogo = useLogo;
exports.useRemoveLogo = useRemoveLogo;
exports.useTeamPhoto = useTeamPhoto;
exports.useRemoveTeamPhoto = useRemoveTeamPhoto;
exports.usePersonalFeaturedPhoto = usePersonalFeaturedPhoto;
exports.usePersonalRemoveFeaturedPhoto = usePersonalRemoveFeaturedPhoto;
exports.make = make;
/* commitMutation Not a pure module */
